import { render } from "./CategoriesWithProductModal.vue?vue&type=template&id=7f5c82d0"
import script from "./CategoriesWithProductModal.vue?vue&type=script&lang=js"
export * from "./CategoriesWithProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__